<button mat-icon-button type="button" (click)="openReminderDialog()"
        [matTooltip]="tooltip"
        matTooltipClass="tooltip-multiline">
  <mat-icon>
    {{ icon }}
  </mat-icon>
</button>
